export default __webpack_public_path__ + "static/media/le_mont11.985cf4b4.jpg";